import { OfferDetails } from "~/utils/getOfferDetails";
import { stringToCurrency } from "~/utils/stringConversion";

type Props = {
  offerDetails: OfferDetails;
  price: number;
};

export const Price = ({ offerDetails, price }: Props) => {
  const { hasCurrentOffer, offerPrice, discount } = offerDetails;

  if (!hasCurrentOffer) return <p>{stringToCurrency({ amount: price })}</p>;

  return (
    <>
      <div className="flex gap-2 items-center text-sm">
        <p className="line-through">{stringToCurrency({ amount: price })}</p>
        <span className="text-secondary-500">
          (Spar {stringToCurrency({ amount: discount })})
        </span>
      </div>
      <p>{stringToCurrency({ amount: offerPrice })}</p>
    </>
  );
};
